import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-icon-calender',
  standalone: true,
  templateUrl: './icon-calender.component.html',
  styleUrl: './icon-calender.component.scss',
})
export class IconCalenderComponent {
  @Input() width = '20';
  @Input() height = '20';
}
